import { render, staticRenderFns } from "./Commerces.vue?vue&type=template&id=56a48972&"
import script from "./Commerces.vue?vue&type=script&lang=ts&"
export * from "./Commerces.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports